import { useMemo } from 'react';
import { useOccConfig } from '../../../context';
export const useSeatToAppearanceMapForRules = (seatAppearanceRulesOverride, seatingData) => {
    const { appearanceRules } = useOccConfig().seating.seats;
    const seatAppearanceRules = seatAppearanceRulesOverride !== null && seatAppearanceRulesOverride !== void 0 ? seatAppearanceRulesOverride : appearanceRules;
    return useMemo(() => {
        const seatAppearanceRuleMap = new Map();
        seatAppearanceRules === null || seatAppearanceRules === void 0 ? void 0 : seatAppearanceRules.forEach(rule => {
            const layoutApplicableSeats = getApplicableSeatsInLayout(rule, seatingData);
            layoutApplicableSeats === null || layoutApplicableSeats === void 0 ? void 0 : layoutApplicableSeats.forEach(seat => {
                if (!seatAppearanceRuleMap.has(seat.id)) {
                    seatAppearanceRuleMap.set(seat.id, rule);
                }
            });
        });
        return seatAppearanceRuleMap;
    }, [seatAppearanceRules, seatingData]);
};
function getApplicableSeatsInLayout(seatAppearanceRule, seatingData) {
    const { siteIds, seatLayoutIds } = seatAppearanceRule.criteria;
    const { seatLayout } = seatingData;
    // rule criteria: site identifier
    if (siteIds && !siteIds.includes(seatingData.siteId)) {
        return [];
    }
    // rule criteria: seat layout identifier
    if (seatLayoutIds && !seatLayoutIds.includes(seatLayout.id)) {
        return [];
    }
    // rule criteria: areas
    const layoutApplicableSeats = seatLayout.areas.flatMap(area => getApplicableSeatsInArea(seatAppearanceRule, seatingData, area));
    return layoutApplicableSeats;
}
function getApplicableSeatsInArea(seatAppearanceRule, seatingData, area) {
    const { areaCategories: ruleAreaCategories, areaNumbers } = seatAppearanceRule.criteria;
    const { areaCategories } = seatingData;
    // rule criteria: area categories
    const areaCategory = areaCategories.find(ac => ac.id === area.areaCategoryId);
    if (areaCategory && ruleAreaCategories) {
        const areaCategoryMatches = (areaCategory.hopk && ruleAreaCategories.includes(areaCategory.hopk)) ||
            ruleAreaCategories.includes(areaCategory.name.text);
        if (!areaCategoryMatches) {
            return [];
        }
    }
    // rule criteria: area numbers
    if (areaNumbers && !areaNumbers.includes(area.number)) {
        return [];
    }
    // rule criteria: rows
    const areaApplicableSeats = area.rows.flatMap(row => getApplicableSeatsInRow(seatAppearanceRule, seatingData, row));
    return areaApplicableSeats;
}
function getApplicableSeatsInRow(seatAppearanceRule, seatingData, row) {
    const { rowNumbers } = seatAppearanceRule.criteria;
    // rule criteria: row position
    if (rowNumbers && !rowNumbers.includes(row.number)) {
        return [];
    }
    // rule criteria: row seats
    const rowApplicableSeats = row.seats.filter(seat => isAppearanceRuleApplicableForSeat(seatAppearanceRule, seatingData, seat));
    return rowApplicableSeats;
}
function isAppearanceRuleApplicableForSeat(seatAppearanceRule, seatingData, seat) {
    const { friendSeatIds } = seatingData;
    const { columnNumbers, seatTypes } = seatAppearanceRule.criteria;
    // rule criteria: seat types
    const isFriendSeat = friendSeatIds === null || friendSeatIds === void 0 ? void 0 : friendSeatIds.includes(seat.id);
    if (seatTypes && !(isFriendSeat ? seatTypes.includes('Friend') : seatTypes.includes(seat.type))) {
        return false;
    }
    // rule criteria: seat position
    if (columnNumbers && !columnNumbers.includes(seat.position.columnNumber)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=use-seat-to-appearance-map-for-rules.js.map